import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/9861699c-84a1-47cb-99a1-a59de1c49b16/workspace/streffy-middle-office_pMRG/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
/**
 * 品牌信息
 * */
import Vue from 'vue';
import util from '@/libs/util.js';
var defBrandInfo = {
  // 集团ID
  groupId: '',
  // 品牌Id
  brandId: '',
  // tenantId
  tenantId: 0,
  // 订单品牌
  orderBrand: ''
};
export default {
  namespaced: true,
  state: {
    // 品牌信息
    brandInfo: {
      // 集团ID
      groupId: '',
      // 品牌Id
      brandId: '',
      // tenantId
      tenantId: null,
      // 订单品牌
      orderBrand: ''
    }
  },
  actions: {
    /**
     * @description 设置品牌数据
     * @param {Object} state vuex state
     * @param {Object} dispatch vuex dispatch
     * @param {*} brandInfo brandInfo
     */
    set: function set(_ref, brandInfo) {
      var state = _ref.state,
        dispatch = _ref.dispatch;
      return new Promise(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                util.TENANTID_LIST = [brandInfo];
                // store 赋值
                state.brandInfo = brandInfo;
                Vue.prototype.$BrandInfo = brandInfo;
                // 持久化
                _context.next = 5;
                return dispatch('admin/db/set', {
                  dbName: 'streffy',
                  path: 'brand.info',
                  value: brandInfo,
                  user: true
                }, {
                  root: true
                });
              case 5:
                // end
                resolve();
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 从数据库取用户数据
     * @param {Object} state vuex state
     * @param {Object} dispatch vuex dispatch
     */
    load: function load(_ref3) {
      var state = _ref3.state,
        dispatch = _ref3.dispatch;
      return new Promise(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dispatch('admin/db/get', {
                  dbName: 'streffy',
                  path: 'brand.info',
                  defaultValue: defBrandInfo,
                  user: true
                }, {
                  root: true
                });
              case 2:
                state.brandInfo = _context2.sent;
                // 返回登录
                if (!state.brandInfo.tenantId) {
                  dispatch('admin/account/logout', {}, {
                    root: true
                  });
                }
                Vue.prototype.$BrandInfo = state.brandInfo;
                util.TENANTID_LIST = [state.brandInfo];
                // end
                resolve();
              case 7:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
  }
};